const standardWithTime = 'EEE do MMM HH:mm'

export default standardWithTime
export { standardWithTime }
